import { render } from "./SearchView.vue?vue&type=template&id=12edb96e&scoped=true"
import script from "./SearchView.vue?vue&type=script&lang=js"
export * from "./SearchView.vue?vue&type=script&lang=js"

import "./SearchView.vue?vue&type=style&index=0&id=12edb96e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12edb96e"]])

export default __exports__